import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Tag ,Divider, Icon, Row, Tooltip, Pagination, Form, Popconfirm,Collapse,Rate, Typography } from 'antd';
import {Field, reduxForm} from "redux-form";
import Loading from '../loading/loading';
import moment from 'jalali-moment'
import TextField from "../formFields/TextField";
import SelectField from "../formFields/SelectField";
import SelectFieldForLoadCity from "../formFields/SelectFieldForLoadCity";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";
import { CSVLink  } from "react-csv";
import DatePickerField from "../formFields/DatePickerField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'4%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width:'9%'
    },
    // {
    //     title: 'ایجاد کننده',
    //     dataIndex: 'createdBy',
    //     width:'9%'
    // },
    {
        title: 'مشتری',
        dataIndex: 'customer_by',
        width:'9%'
    },
    {
        title: 'آدرس',
        dataIndex: 'address',
        width:'18%'
    },
    {
        title: 'تکنیسن',
        dataIndex: 'technician_by',
        width:'9%'
    },
    // {
    //     title: 'نوع درخواست',
    //     dataIndex: 'order_type',
    //     width:'9%'
    // },
    {
        title: 'وضعیت سفارش',
        dataIndex: 'current_status',
        width:'7%'
    },
    {
        title: 'تاریخ ارجاع',
        dataIndex: 'schedule_time',
        width:'6%'
    },
    // {
    //     title: 'ساعت',
    //     dataIndex: 'schedule_hour',
    //     width:'4%'
    // },
    {
        title: 'درخواست اولیه',
        dataIndex: 'status_history',
        width:"17%"
    },
    // {
    //     title: 'نوع پرداخت',
    //     dataIndex: 'payment_type',
    //     width:'10%'
    // },
    {
        title: 'موبایل مشتری',
        dataIndex: 'customer_mobile',
        width:'10%'
    },
    {
        title: 'تسویه مشتری',
        dataIndex: 'customer_settle',
    },
    {
        title: 'تسویه تکنسین',
        dataIndex: 'technician_settle',
    },
    {
        title: 'تاریخ تسویه',
        dataIndex: 'technician_settle_time',
        width:'6%'
    },
    {
        title: 'نظر',
        dataIndex: 'comment',
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width:'15%'
    },
  ];
const header = [
    {
        label: 'مشتری',
        key: 'customer_by',
    },
    {
        label: 'تکنیسن',
        key: 'technician_by',
    },
    {
        label: 'آدرس',
        key: 'address',
    },
    // {
    //     label: 'نوع درخواست',
    //     key: 'order_type',
    // },
    {
        label: 'وضعیت سفارش',
        key: 'current_status',
    },
    {
        label: 'تاریخ ارجاع',
        key: 'schedule_time',
    },
    // {
    //     label: 'ساعت',
    //     key: 'schedule_hour',
    // },
    {
        label: 'درخواست اولیه',
        key: 'referrer',
    },
    // {
    //     label: 'نوع پرداخت',
    //     key: 'payment_type',
    // },
    {
        label: 'موبایل مشتری',
        key: 'customer_mobile',
    },
    {
        label: 'تسویه مشتری',
        key: 'customer_settle',
    },
    {
        label: 'تسویه تکنسین',
        key: 'technician_settle',
    },
    {
        label: 'تاریخ تسویه',
        key: 'technician_settle_time',
    },
    {
        label: 'کد سیستمی',
        key: 'system_code',
    },
];
const logsColumn = [
    {
        title: 'ردیف',
        dataIndex: 'key',
    },
    {
        title: 'نام و نام خانوادگی',
        dataIndex: 'fullName',
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
    },
    {
        title: 'توضیحات',
        dataIndex: 'operation_title',
    },
    {
        title: 'تاریخ',
        dataIndex: 'date',
    },
];

const expandedRowRender = record => <div>{record.extraInfo}</div>;

class InvoiceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formLayout: 'horizontal',
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:false,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            visible: false,
            expandedRowRender,
            filter:[],
            search:false,
            customer_by:this.props.match.params.userId ? this.props.match.params.userId : '',
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        this.props.getUserList({role:"TECHNICIAN",size:100});
    }
    componentDidMount() {
        let _ = require('lodash');
        this.props.getAreaList();
        // this.props.getStateList({size:50});
        this.props.getStateList({size:10});
        // this.props.getCityList({size:200});
        // this.props.getCityList({size:10});
        this.props.getCityList({size:200});
        // this.props.getListForExcel({size:10000});
        if(this.props.match.params.userId) {
            let userId = this.props.match.params.userId;
            if(_.includes(this.props.match.path,'customer')) {
                this.props.getList({customer_by: userId})
                this.setState(prevState  => ({
                    filter: {...prevState.filter,customer_by:userId}
                }))
            }else {
                this.setState(prevState  => ({
                    filter: {...prevState.filter,technician_by:userId}
                }))
                this.props.getList({technician_by: userId})
            }
            this.props.getUserInfo(userId)
        }else{
            this.props.getList()
            // this.interval = setInterval(() => this.props.getList(), 20000);
        }
    }

   /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        clearInterval(this.interval);
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        if(this.state.system_code)
            this.setState(prevState  => ({
                filter: {...prevState.filter,system_code:this.state.system_code}
            }))
        if(this.state.created_from)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_from:this.state.created_from}
            }))
        if(this.state.created_to)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_to:this.state.created_to}
            }))
        if(this.state.current_status)
            this.setState(prevState  => ({
                filter: { ...prevState.filter,current_status:this.state.current_status}
            }))
        if(this.state.stateId)
            this.setState(prevState  => ({
                filter: {...prevState.filter,state:this.state.stateId}
            }))
        if(this.state.city)
            this.setState(prevState  => ({
                filter: {...prevState.filter,city:this.state.city}
            }))
        if(this.state.customer_settle)
            this.setState(prevState  => ({
                filter: {...prevState.filter,customer_settle:this.state.customer_settle}
            }))
        if(this.state.technician_settle)
            this.setState(prevState  => ({
                filter: {...prevState.filter,technician_settle:this.state.technician_settle}
            }))
        if(this.state.dateStatus)
            this.setState(prevState  => ({
                filter: {...prevState.filter,dateStatus:this.state.dateStatus}
            }))
        if(this.state.customer_mobile)
            this.setState(prevState  => ({
                filter: {...prevState.filter,customer_mobile:this.state.customer_mobile}
            }))
        this.props.handleSubmit(value);
        clearInterval(this.interval);
    }

    confirmForEditInvoice(orderId) {
        this.props.editInvoice(orderId)
        this.forceUpdate()
        this.props.getList();
    }

    __translateStatus(status){
        switch (status) {
            case 'ORDER_CREATED_BY_CUSTOMER':
                return <Tag style={{marginRight:0,fontSize:10}} color="green">ثبت شده توسط کاربر</Tag>;
            case 'ORDER_CREATED':
                return <Tag style={{marginRight:0,fontSize:10}} color="gold">در انتظار بررسی</Tag>;
            case 'ORDER_ASSIGNED':
                return <Tag style={{marginRight:0,fontSize:10}} color="cyan">انتخاب تکنسین</Tag>;
            case 'ORDER_CANCELED_BY_CUSTOMER':
                return <Tag style={{marginRight:0,fontSize:10}} color="red">لفو توسط مشتری</Tag>;
            case 'ORDER_CANCELED_BY_TECHNICIAN':
                return <Tag style={{marginRight:0,fontSize:10}} color="yellow">لغو توسط تکنسین</Tag>;
            case 'ORDER_CANCELED_BY_OPERATOR':
                return <Tag style={{marginRight:0,fontSize:10}} color="lightSeaGreen">لغو توسط اپراتور</Tag>;
            case 'ORDER_COMPLETED':
                return <Tag style={{marginRight:0,fontSize:10}} color="blue">تکمیل درخواست</Tag>;
            case 'ORDER_PENDING':
                return <Tag style={{marginRight:0,fontSize:10}} color="orange">تعلیق درخواست</Tag>;
        }
    }

    __translatePaymentType(type,price=null){
        switch (type) {
            case 'INVOICE_IPG_PAYMENT':
                if(price > 0)
                    return 'پرداخت اینترنتی';
                else
                    return 'موجودی کاربر';
            case 'INVOICE_CHEQUE_PAYMENT':
                return 'پرداخت چک';
            case 'INVOICE_POS_PAYMENT':
                return 'پرداخت با دستگاه پوز';
            case 'INVOICE_CASH_PAYMENT':
                return 'پرداخت نقدی';
            case 'INVOICE_ORDER_COST':
                return 'لغو توسط اپراتور';
            case 'INVOICE_DISCOUNT':
                return 'تخفیف دار';
            case 'INVOICE_COMMISSION':
                return 'پورسانت';
            case 'INVOICE_SETTLEMENT':
                return 'تکمیل شده';
            case 'INVOICE_CORRECTIVE':
                return 'اصلاح شده';
            case 'INVOICE_GIFT_CREDIT':
                return 'هدیه';
            default:
                return 'پرداخت نشده';
        }
    }

    __translateApproximateTime(type){
        switch (type) {
            case 'TODAY_AM':
                return 'امروز صبح';
            case 'TODAY_PM':
                return 'امروز بعدازظهر';
            case 'TOMORROW_AM':
                return 'فردا صبح';
            case 'TOMORROW_PM':
                return 'فردا بعدازظهر';
            case 'EXACT_DATE':
                return 'زمان دقیق';
        }
    }

    __getUserList() {
        let userList = this.props.userList;
        let dataSource = [];

        if (userList && userList.lists) {

            for (let i = 0; i < userList.lists.length; i++) {

                if(userList.lists[i].role == "TECHNICIAN")
                    dataSource.push(
                        {label: userList.lists[i].name+' '+userList.lists[i].family, value: userList.lists[i]._id, key: i}
                    );

            }

        }
        return dataSource;
    }

    __fixListForShowInTable() {
        let list = this.props.list;
        const {Text} = Typography;
        let dataSource = [];
        let fixtures = '';
        let product;
        let customerSettle;
        let technicianSettle;
        let comment;
        let extraInfo;
        let scheduleTime;
        let orderRate=0;
        const { Panel } = Collapse;
        let _ = require('lodash');
        let stateList = []
        let cityList = []

        if(this.props.stateList)
            stateList = this.props.stateList.lists

        if(this.props.cityList)
            cityList = this.props.cityList.lists

        if(list && list.lists) {

            for (let i = 0; i < list.lists.length; i++) {
                let logs = [];
                let invoiceInfo = [];
                let invoiceInfo2 = [];
                let cheque = [];
                let chequeBankName;
                let chequeAmount;
                let chequeNumber;
                let referrer;
                let fixReferrer;
                let stateName;
                let cityName;
                let address;

                /*---- stateName ----*/
                stateList.map((state,index) => {
                    if(state._id === list.lists[i].address.stateId)
                        stateName = state.title
                })

                /*---- cityName ----*/
                cityList.map((city,index) => {
                    if(city._id === list.lists[i].address.cityId)
                        cityName = city.title
                })

                /*---- logs ----*/
                if(list.lists[i].status_history) {
                    for (let j = 0; j < list.lists[i].status_history.length; j++) {
                        if (list.lists[i].status_history[j].operation_title){
                            logs.push({
                                key: (j),
                                system_code: list.lists[i].status_history[j].system_code ? list.lists[i].status_history[j].system_code : '',
                                fullName: list.lists[i].status_history[j].fullname ? list.lists[i].status_history[j].fullname : '',
                                operation_title: list.lists[i].status_history[j].operation_title ? list.lists[i].status_history[j].operation_title : '',
                                date: list.lists[i].status_history[j].operation_date ? moment(list.lists[i].status_history[j].operation_date).format('jYYYY/jM/jD') : '',
                            });
                        }
                    }

                }

                address= stateName+' - '+cityName+' - '+list.lists[i].address.text

                if(list.lists[i].schedule_time && list.lists[i].schedule_hour)
                    scheduleTime = moment(list.lists[i].schedule_time).format('jYYYY/jM/jD')
                else
                    scheduleTime = ''

                if(list.lists[i].customer_settle)
                    customerSettle = <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" key={i} />
                else
                    customerSettle = <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96"  key={i} />

                if(list.lists[i].technician_settle)
                    technicianSettle = <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" key={i}  />
                else
                    technicianSettle = <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" key={i}  />

                if(list.lists[i].has_comment)
                    comment = <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" key={i}  />
                else
                    comment = <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" key={i}  />


                if(list.lists[i].invoice) {
                    if ((list.lists[i].invoice.services && list.lists[i].invoice.services.length > 0)
                    || (list.lists[i].invoice.products && list.lists[i].invoice.products.length > 0)) {
                        let invoiceLength = list.lists[i].invoice.services.length;
                        let productLength = list.lists[i].invoice.products.length;
                        let invoiceText;
                        let invoicePrice = 0;
                        let invoiceTitle;
                        let invoiceCount;
                        for (let j = 0; j < invoiceLength; j++) {
                            if(list.lists[i].invoice.services[j].price)
                                invoicePrice = (list.lists[i].invoice.services[j].price).toLocaleString(navigator.language, {minimumFractionDigits: 0})
                            if(list.lists[i].invoice.services[j].title)
                                invoiceTitle = list.lists[i].invoice.services[j].title
                            if(list.lists[i].invoice.services[j].count)
                                invoiceCount = list.lists[i].invoice.services[j].count
                            invoiceText = <Row key={'s'+j}>
                                <strong style={{float: 'right'}} key={j+1}>{invoiceTitle} : </strong>
                                <span style={{float: 'right'}}>{invoicePrice} ریال</span>
                                <span style={{float: 'right',marginRight:10}}>(تعداد : {invoiceCount})</span>
                            </Row>;
                            invoiceInfo.push(invoiceText)
                        }
                        for (let k = 0; k < productLength; k++) {
                            if(list.lists[i].invoice.products[k].price)
                                invoicePrice = (list.lists[i].invoice.products[k].price).toLocaleString(navigator.language, {minimumFractionDigits: 0})
                            if(list.lists[i].invoice.products[k].title)
                                invoiceTitle = list.lists[i].invoice.products[k].title
                            if(list.lists[i].invoice.products[k].count)
                                invoiceCount = list.lists[i].invoice.products[k].count
                            invoiceText = <Row key={'p'+k}>
                                <strong style={{float: 'right'}} key={k+1}>{invoiceTitle} : </strong>
                                <span style={{float: 'right'}}>{invoicePrice} ریال</span>
                                <span style={{float: 'right',marginRight:10}}>(تعداد : {invoiceCount})</span>
                            </Row>;
                            invoiceInfo2.push(invoiceText)
                        }
                    }

                    if(list.lists[i].invoice.cheque && list.lists[i].invoice.cheque.length > 0){
                        for (let m = 0; m < list.lists[i].invoice.cheque.length; m++) {
                            if(list.lists[i].invoice.cheque[m].bank_name)
                                chequeBankName = <RTLCol md={8} key={m+1}>
                                    <strong style={{float: 'right'}} key={m+1}>نام بانک : </strong>
                                    {list.lists[i].invoice.cheque[m].bank_name}
                                </RTLCol>

                            if(list.lists[i].invoice.cheque[m].amount)
                                chequeAmount = <RTLCol md={8}  key={m+1}>
                                    <strong style={{float: 'right'}} key={m+1}>مبلغ : </strong>
                                    {(list.lists[i].invoice.cheque[m].amount).toLocaleString(navigator.language, {minimumFractionDigits: 0})}
                                </RTLCol>

                            if(list.lists[i].invoice.cheque[m].cheque_number)
                                chequeNumber = <RTLCol md={8}  key={m+1}>
                                    <strong style={{float: 'right'}} key={m+1}>شماره چک : </strong>
                                    {list.lists[i].invoice.cheque[m].cheque_number}
                                </RTLCol>


                            cheque.push(chequeNumber,chequeAmount,chequeBankName)
                        }
                    }

                }

                if(list.lists[i].rate){
                    let splitRate = _.split(list.lists[i].rate,'.')
                    orderRate = splitRate[0]
                }

                if(list.lists[i])
                    extraInfo = <Collapse className="extraInfoWrapper">
                        <Panel header="اطلاعات بیشتر" key="1">
                            <Row className="collapseText">
                                {list.lists[i].description ?
                                    <div>
                                        <strong>توضیحات : </strong>
                                        {list.lists[i].description}
                                    </div>
                                    :null}
                                {list.lists[i].approximate_time ?
                                    <div>
                                        <strong>تاریخ پیشنهادی مشتری جهت انجام درخواست : </strong>
                                        {list.lists[i].approximate_time != "EXACT_DATE" ?
                                            this.__translateApproximateTime(list.lists[i].approximate_time):
                                            list.lists[i].schedule_time ? moment(list.lists[i].schedule_time).format('jYYYY/jM/jD') : ''
                                        }
                                    </div>
                                    :null}
                                {list.lists[i].created_at ?
                                    <div>
                                        <strong>تاریخ ایجاد درخواست : </strong>
                                        {list.lists[i].created_at ? moment(list.lists[i].created_at).format('jYYYY/jM/jD') : ''}
                                    </div>
                                    :null}
                            </Row>
                        </Panel>{list.lists[i].current_status === 'ORDER_PENDING' ?
                            <Panel header="دلیل تعلیق درخواست" key="7">
                                <Row className="collapseText">
                                    {list.lists[i].pending_description ?
                                        <div>
                                            <strong>توضیحات : </strong>
                                            {list.lists[i].pending_description}
                                        </div>
                                    :null}
                                </Row>
                            </Panel>
                        : null}

                        {list.lists[i].current_status === "ORDER_CANCELED_BY_OPERATOR" || list.lists[i].current_status === "ORDER_CANCELED_BY_TECHNICIAN" ?
                            <Panel header="دلیل لغو درخواست" key="8">
                                <Row className="collapseText">
                                    {list.lists[i].cancel_description ?
                                        <div>
                                            <strong>توضیحات : </strong>
                                            {list.lists[i].cancel_description}
                                        </div>
                                    :null}
                                </Row>
                            </Panel>
                        : null}
                        {list.lists[i].current_status === "ORDER_CANCELED_BY_CUSTOMER" ?
                            <Panel header="دلیل لغو درخواست توسط مشتری" key="8">
                                <Row className="collapseText">
                                    {list.lists[i].customer_cancel_description ?
                                        <div>
                                            <strong>توضیحات : </strong>
                                            {list.lists[i].customer_cancel_description}
                                        </div>
                                        :null}
                                </Row>
                            </Panel>
                            : null}
                        <Panel header="مشخصات مشتری" key="2">
                            {list.lists[i].customer_by ?
                                <Row className="collapseText">
                                    <div>
                                        <strong>نام : </strong>
                                        {list.lists[i].customer_by.name ? list.lists[i].customer_by.name : null}
                                    </div>
                                    <div>
                                        <strong>نام و نام خانوادگی : </strong>
                                        {list.lists[i].customer_by.family ? list.lists[i].customer_by.family : null}
                                    </div>
                                    <div>
                                        <strong>موبایل : </strong>
                                        {list.lists[i].customer_by.mobile ? list.lists[i].customer_by.mobile: null}
                                    </div>
                                    <div>
                                        <strong>تلفن ثابت : </strong>
                                        {list.lists[i].customer_by.phone_number ? list.lists[i].customer_by.phone_number: null}
                                    </div>
                                    <div>
                                        <strong>آدرس : </strong>
                                        {stateName+' - '+cityName+' - '+list.lists[i].address.text}
                                    </div>
                                </Row>
                            :null}
                        </Panel>
                        <Panel header="مشخصات تکنسین" key="3">
                            {list.lists[i].technician_by ?
                                <Row className="collapseText">
                                    <div>
                                        <strong>نام : </strong>
                                        {list.lists[i].technician_by.name ? list.lists[i].technician_by.name : null}
                                    </div>
                                    <div>
                                        <strong>نام و نام خانوادگی : </strong>
                                        {list.lists[i].technician_by.family ? list.lists[i].technician_by.family : null}
                                    </div>
                                    <div>
                                        <strong>شماره همراه : </strong>
                                        {list.lists[i].technician_by.mobile ? list.lists[i].technician_by.mobile : null}
                                    </div>
                                </Row>
                                :<Row className="collapseText">تکنسین اختصاص داده نشده</Row>}
                        </Panel>
                        <Panel header="مشاهده فاکتور (خدمات نهایی)" key="4">
                            {list.lists[i].invoice ?
                                <Row className="collapseText">
                                    {_.concat(invoiceInfo, invoiceInfo2)}
                                    <div>
                                        <strong>مبلغ تخفیفات و هدیه : </strong>
                                        {list.lists[i].invoice.discounts ? (list.lists[i].invoice.discounts-list.lists[i].guarantee_amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0}
                                    </div>
                                    <div>
                                        <strong>مبلغ گارانتی : </strong>
                                        {list.lists[i].guarantee_amount ? list.lists[i].guarantee_amount.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0}
                                    </div>
                                    <div>
                                        <strong>هزینه ایاب و ذهاب : </strong>
                                        {list.lists[i].invoice.commuting.commuting_fee ? (list.lists[i].invoice.commuting.commuting_fee).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0}
                                    </div>
                                    <div>
                                        <strong>مبلغ فاکتور : </strong>
                                        {list.lists[i].invoice.final_price ? (list.lists[i].invoice.final_price).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0}
                                    </div>
                                    <div>
                                        <strong>مبلغ قابل پرداخت : </strong>
                                        {list.lists[i].invoice.price_to_payment ? (list.lists[i].invoice.price_to_payment).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0}
                                    </div>
                                </Row>
                                :null}
                        </Panel>
                        <Panel header="مشاهده پرداختی ها" key="5">
                            {list.lists[i].invoice ?
                                <Row className="collapseText">
                                    <div>
                                        {list.lists[i].invoice ? _.concat(cheque) : ''}
                                    </div>
                                    <div>
                                        {list.lists[i].invoice.cash ?
                                            <strong>پرداخت نقدی : </strong>
                                        : null}
                                        {list.lists[i].invoice.cash ? list.lists[i].invoice.cash : ''}
                                    </div>
                                    <div>
                                        {list.lists[i].invoice.pos ?
                                            <strong>پرداخت دستگاه پوز : </strong>
                                        : null}
                                        {list.lists[i].invoice.pos ? list.lists[i].invoice.pos : ''}
                                    </div>
                                    <div>
                                        {list.lists[i].payment_type === 'INVOICE_IPG_PAYMENT' && list.lists[i].invoice.price_to_payment > 0 ?
                                            <strong>پرداخت اینترنتی : </strong>
                                        : <strong>موجودی کاربر </strong>}
                                        {list.lists[i].payment_type === 'INVOICE_IPG_PAYMENT' && list.lists[i].invoice.price_to_payment > 0 ?
                                            list.lists[i].invoice.price_to_payment :
                                            ''}
                                    </div>
                                </Row>
                            :null}
                        </Panel>
                        <Panel header="مشاهده نظرات" key="6">
                            {list.lists[i].has_comment ?
                                <Row className="collapseText">
                                    <div>
                                        <strong>امتیاز : </strong>
                                        <Rate disabled defaultValue={parseInt(orderRate)} />
                                    </div>
                                    <div>
                                        <strong>متن نظر : </strong>
                                        {list.lists[i].feedback}
                                    </div>
                                </Row>
                                :null}
                        </Panel>
                        <Panel header="مشاهده سابقه" key="7">
                            {list.lists[i].status_history ?
                                <Row className="collapseText">
                                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={logsColumn} dataSource={logs} size="small" />
                                </Row>
                            :null}
                        </Panel>
                    </Collapse>
                else
                    extraInfo = ''

                if(list.lists[i].order_type === 'ORDER_TYPE_BUY') {
                    if(list.lists[i].product)
                        product = list.lists[i].product.title
                }
                else {
                    if(list.lists[i].fixtures) {
                        for(let j=0 ; j<list.lists[i].fixtures.length ; j++){
                            fixtures += list.lists[i].fixtures[j].title +' - ';
                        }
                    }
                    fixtures=fixtures.substring(0, fixtures.length - 3);
                }

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    order_type : (list.lists[i].order_type === 'ORDER_TYPE_BUY' ? 'خرید دستگاه' : 'تعمیرات'),
                    current_status: this.__translateStatus(list.lists[i].current_status),
                    schedule_time: scheduleTime,
                    schedule_hour: list.lists[i].schedule_hour ? list.lists[i].schedule_hour : '',
                    referrer: referrer ? referrer.fullname : '',
                    status_history : list.lists[i].order_type === 'ORDER_TYPE_BUY' ? 'درخواست خرید محصول: '+product : 'درخواست تعمیرات شامل: '+fixtures,
                    // payment_type: list.lists[i].customer_settle == true && list.lists[i].payment_type && list.lists[i].invoice != null ?  <Text type="success">{this.__translatePaymentType(list.lists[i].payment_type,list.lists[i].invoice.price_to_payment)}</Text> : <Text type="danger">پرداخت نشده</Text>,
                    customer_settle: customerSettle,
                    technician_settle: technicianSettle,
                    comment: comment,
                    technician_settle_time:moment(list.lists[i].technician_settle_time).format('jYYYY/jM/jD'),
                    technician_by:list.lists[i].technician_by.name+" "+list.lists[i].technician_by.family,
                    customer_by:list.lists[i].customer_by.name+" "+list.lists[i].customer_by.family,
                    customer_mobile:list.lists[i].customer_by.mobile,
                    createdBy:list.lists[i].createdBy!=undefined?list.lists[i].createdBy.name+" "+list.lists[i].createdBy.family:'-',
                    approximate_time: this.__translateApproximateTime(list.lists[i].approximate_time),
                    extraInfo: extraInfo,
                    address:address,
                    action: <span>
                                {(list.lists[i].current_status !='ORDER_ASSIGNED' && list.lists[i].current_status != 'ORDER_COMPLETED' && list.lists[i].current_status != "ORDER_CANCELED_BY_OPERATOR" && list.lists[i].current_status != "ORDER_CANCELED_BY_TECHNICIAN" && list.lists[i].current_status != "ORDER_CANCELED_BY_CUSTOMER"?
                                    <>
                                        <Tooltip placement="top" title="انتخاب تکنسین">
                                            <a href={"#/order/assign/"+list.lists[i]._id} className="listBtn"><Icon type="check" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                    : null )}
                                {(list.lists[i].current_status == 'ORDER_COMPLETED' && list.lists[i].technician_settle != true ?
                                    <>
                                        <Tooltip placement="top" title="تسویه فاکتور">
                                            <a href={"#/order/settle/"+list.lists[i]._id} className="greenListBtn"><Icon type="dollar-circle" theme="filled" /></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null)}
                                {(list.lists[i].current_status != 'ORDER_COMPLETED' && list.lists[i].current_status != "ORDER_CANCELED_BY_OPERATOR" && list.lists[i].current_status != "ORDER_CANCELED_BY_TECHNICIAN" && list.lists[i].current_status != "ORDER_CANCELED_BY_CUSTOMER"?
                                    <>
                                        <Tooltip placement="top" title="تعلیق">
                                            <a href={"#/order/pending/"+list.lists[i]._id} className="purpleListBtn"><Icon type="poweroff" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null )}
                                {(list.lists[i].current_status != 'ORDER_COMPLETED' && list.lists[i].current_status != "ORDER_CANCELED_BY_OPERATOR" && list.lists[i].current_status != "ORDER_CANCELED_BY_TECHNICIAN" && list.lists[i].current_status != "ORDER_CANCELED_BY_CUSTOMER"?
                                    <>
                                        <Tooltip placement="top" title="وضعیت تماس">
                                            <a href={"#/order/call/"+list.lists[i]._id} className="purpleListBtn"><Icon type="phone" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null )}
                                {(list.lists[i].current_status =='ORDER_COMPLETED' && list.lists[i].customer_settle == true && list.lists[i].technician_settle == false?
                                    <>
                                        <Tooltip placement="top" title="لغو سفارش پرداخت شده">
                                            <a href={"#/order/new/invoice/"+list.lists[i]._id} className="purpleListBtn"><Icon type="swap" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null )}
                                {(list.lists[i].current_status =='ORDER_ASSIGNED' && list.lists[i].current_status != 'ORDER_COMPLETED' && list.lists[i].current_status != "ORDER_CANCELED_BY_OPERATOR" && list.lists[i].current_status != "ORDER_CANCELED_BY_TECHNICIAN" && list.lists[i].current_status != "ORDER_CANCELED_BY_CUSTOMER"?
                                    <>
                                        <Tooltip placement="top" title="تکمیل فاکتور">
                                            <a href={"#/order/tech/"+list.lists[i]._id} className="blueListBtn"><Icon type="account-book" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null )}
                                {(list.lists[i].current_status =='ORDER_COMPLETED' && list.lists[i].customer_settle === false ?
                                    <>
                                        <Tooltip placement="top" title="پرداخت فاکتور">
                                            <a href={"#/order/cash/"+list.lists[i]._id} className="listBtn"><Icon type="credit-card" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null )}
                                {(list.lists[i].current_status != 'ORDER_COMPLETED' && list.lists[i].current_status != "ORDER_CANCELED_BY_OPERATOR" && list.lists[i].current_status != "ORDER_CANCELED_BY_TECHNICIAN" && list.lists[i].current_status != "ORDER_CANCELED_BY_CUSTOMER"?
                                    <>
                                        <Tooltip placement="top" title="حذف">
                                            <a href={"#/order/cancel/"+list.lists[i]._id} className="redListBtn"><Icon type="close" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null )}
                                {(list.lists[i].current_status === 'ORDER_COMPLETED' && list.lists[i].customer_settle === false && list.lists[i].technician_settle === false  ?
                                    <Popconfirm
                                        title="آیا از ویرایش فاکتور مطمئنید؟"
                                        onConfirm={this.confirmForEditInvoice.bind(this,list.lists[i]._id)}
                                        onCancel={this.cancel}
                                        okText="بلی"
                                        cancelText="خیر"
                                        placement="right"
                                    >
                                        <Tooltip placement="top" title="اصلاح فاکتور">
                                            <a href={"#/order/invoice/"+list.lists[i]._id} className="blueListBtn"><Icon type="edit" style={{top:'2px',position: 'relative'}}/></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </Popconfirm>
                                : null )}
                                {(list.lists[i].product_type === 'ORDER_COMPLETED' ?
                                    <>
                                        <Tooltip placement="top" title="گزارش انبار">
                                            <a href={"#/warehouse/order/"+list.lists[i]._id} className="purpleListBtn"><Icon type="bars" /></a>
                                        </Tooltip>
                                        <Divider type="vertical" />
                                    </>
                                : null)}

                                {(list.lists[i].customer_by && list.lists[i].customer_by.role === 'CUSTOMER'?
                                    <Tooltip placement="top" title="ایجاد درخواست">
                                        <a href={"#/order/add/"+list.lists[i].customer_by.mobile+"/"+list.lists[i].customer_by._id} className="greenListBtn2"><Icon type="plus" /></a>
                                    </Tooltip>
                                    : null)}
                            </span>
                });
            }
        }

        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    async __onChangeCounter(current, pageSize) {
        clearInterval(this.interval);
        this.setState({size:pageSize});
        this.setState({pageSize:pageSize})
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        if(this.props.match.params.userId) {
            let userId = this.props.match.params.userId;
            this.props.getList({technician_by:userId})
        }else{
            this.props.getList();
        }
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    StatusExcel(status){
        switch (status) {
            case 'ORDER_CREATED_BY_CUSTOMER':
                return'ثبت شده توسط کاربر'
            case 'ORDER_CREATED':
                return 'در انتظار بررسی'
            case 'ORDER_ASSIGNED':
                return 'انتخواب تکنسین'
            case 'ORDER_CANCELED_BY_CUSTOMER':
                return 'لغو توسط مشتری'
            case 'ORDER_CANCELED_BY_TECHNICIAN':
                return 'لغو توسط تکنسین'
            case 'ORDER_CANCELED_BY_OPERATOR':
                return 'لفو توسط اپراتور'
            case 'ORDER_COMPLETED':
                return 'تکمیل درخواست'
            case 'ORDER_PENDING':
                return 'تعلیق درخواست'
        }
    }

    PaymentTypeExcel(type,price=null){
        switch (type) {
            case 'INVOICE_IPG_PAYMENT':
                if(price > 0)
                    return 'پرداخت اینترنتی';
                else
                    return 'موجودی کاربر';
            case 'INVOICE_CHEQUE_PAYMENT':
                return 'پرداخت چک';
            case 'INVOICE_POS_PAYMENT':
                return 'پرداخت با دستگاه پوز';
            case 'INVOICE_CASH_PAYMENT':
                return 'پرداخت نقدی';
            case 'INVOICE_ORDER_COST':
                return 'لغو توسط اپراتور';
            case 'INVOICE_DISCOUNT':
                return 'تخفیف دار';
            case 'INVOICE_COMMISSION':
                return 'پورسانت';
            case 'INVOICE_SETTLEMENT':
                return 'تکمیل شده';
            case 'INVOICE_CORRECTIVE':
                return 'اصلاح شده';
            case 'INVOICE_GIFT_CREDIT':
                return 'هدیه';
            default:
                return 'پرداخت نشده';
        }
    }

    showExcel() {
        let list = this.props.list;
        const {Text} = Typography;
        let customerSettle;
        let technicianSettle;
        let scheduleTime;
        let _ = require('lodash');
        let a=[];
        let stateList = []
        let cityList = []

        if(this.props.stateList)
            stateList = this.props.stateList.lists

        if(this.props.cityList)
            cityList = this.props.cityList.lists

        if(list && list.lists) {

            for (let i = 0; i < list.lists.length; i++) {
                let referrer;
                let stateName;
                let cityName;
                let address;

                if(list.lists[i].schedule_time && list.lists[i].schedule_hour)
                    scheduleTime = moment(list.lists[i].schedule_time).format('jYYYY/jM/jD')
                else
                    scheduleTime = ''

                if(list.lists[i].customer_settle)
                    customerSettle = 'تسویه'
                else
                    customerSettle = 'تسویه نشده'

                if(list.lists[i].technician_settle)
                    technicianSettle = 'تسویه'
                else
                    technicianSettle = 'تسویه نشده'

                /*---- stateName ----*/
                stateList.map((state,index) => {
                    if(state._id === list.lists[i].address.stateId)
                        stateName = state.title
                })

                /*---- cityName ----*/
                cityList.map((city,index) => {
                    if(city._id === list.lists[i].address.cityId)
                        cityName = city.title
                }) 
                
                address= stateName+' - '+cityName+' - '+list.lists[i].address.text

                a.push({
                    system_code: list.lists[i].system_code,
                    createdBy:list.lists[i].createdBy!=undefined?list.lists[i].createdBy.name+" "+list.lists[i].createdBy.family:'-',
                    customer_by:list.lists[i].customer_by.name+" "+list.lists[i].customer_by.family,
                    technician_by:list.lists[i].technician_by.name+" "+list.lists[i].technician_by.family,
                    order_type : (list.lists[i].order_type === 'ORDER_TYPE_BUY' ? 'خرید دستگاه' : 'تعمیرات'),
                    current_status: this.StatusExcel(list.lists[i].current_status),
                    schedule_time: scheduleTime,
                    schedule_hour: list.lists[i].schedule_hour ? list.lists[i].schedule_hour : '',
                    referrer: referrer ? referrer.fullname : '',
                    // payment_type:this.PaymentTypeExcel(list.lists[i].payment_type,list.lists[i].invoice.price_to_payment),
                    customer_mobile:list.lists[i].customer_by.mobile,
                    customer_settle: customerSettle,
                    technician_settle: technicianSettle,
                    technician_settle_time:moment(list.lists[i].technician_settle_time).format('jYYYY/jM/jD'),
                    address:address,
                });
            }
        }

        return a
    }

    render() {
        let _self = this;
        const {searchBoxHidden } = this.state;
        const { list } = this.props;
        let fromDateVal;
        // var data = this.__fixListForShowInExcel()

        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();
        var cityList = [];

        if(this.state.stateId){
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        if(this.state.fromDate && this.state.fromDate._d)
            fromDateVal = this.state.fromDate._d

        var data = this.showExcel();

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">گزارش فاکتور های تسویه شده</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {data.length>0?
                            <RTLButton type="primary" className="userListBtn" shape="round" >
                                <CSVLink
                                    data={data}
                                    headers={header}
                                    className='export-link'
                                    filename={"invoice-report.csv"}
                                    target="_blank"
                                >
                                    خروجی اکسل
                                </CSVLink>
                                
                            </RTLButton>
                        :null}
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="system_code"
                                    component={TextField}
                                    type="text"
                                    placeholder="کد سیستمی"
                                    onBlur={(system_code) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,system_code:system_code.target.value}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="customer_mobile"
                                    component={TextField}
                                    type="text"
                                    placeholder="شماره همراه"
                                    maxLength={11}
                                    onBlur={(customer_mobile) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,customer_mobile:customer_mobile.target.value}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="technician_by"
                                    component={SelectField}
                                    placeholder="تکنسین"
                                    list={this.__getUserList()}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="state"
                                    component={SelectFieldForLoadState}
                                    placeholder="استان"
                                    list={stateList}
                                    onChangeVal={(stateId) => {
                                        _self.setState({stateId : stateId})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,stateId:stateId}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="city"
                                    component={SelectFieldForLoadCity}
                                    placeholder="شهر"
                                    list={cityList}
                                    onChange={(city) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,city:city}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="customer_settle"
                                    component={SelectField}
                                    placeholder="وضعیت تسویه مشتری"
                                    list={[
                                        {label: 'تسویه شده', value: 'true', key: 1},
                                        {label: 'تسویه نشده', value: 'false', key: 2}
                                    ]}
                                    onChange={(customer_settle) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,customer_settle:customer_settle}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="technician_settle"
                                    component={SelectField}
                                    placeholder="وضعیت تسویه تکنسین"
                                    list={[
                                        {label: 'تسویه شده', value: 'true', key: 1},
                                        {label: 'تسویه نشده', value: 'false', key: 2}
                                    ]}
                                    onChange={(technician_settle) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,technician_settle:technician_settle}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="از تاریخ"
                                    timePicker={false}
                                    onChange={(created_from) => {
                                        _self.setState({created_from : created_from})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,created_from:created_from}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                    onChange={(created_to) => {
                                        _self.setState({created_to : created_to})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,created_to:created_to}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } {...this.state} className="orderList" pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        {this.state.filter.customer_mobile ? null :
                            <Pagination
                                name="pageNum"
                                current={this.state.current}
                                total={(list ? list.count : this.state.size)}
                                onChange={(pageNum) => this.handlePageChange(pageNum)}
                                pageSizeOptions={['10', '20','30','40','50','60','70','80','90','100']}
                                showSizeChanger
                                onShowSizeChange={this.__onChangeCounter}
                            />
                        }
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
          </div>
        );
    }

}

export default InvoiceList = reduxForm({
    form: 'list',
})(InvoiceList)
